import axios from 'axios';
import qs from 'qs';
import { ProvinceData, ProvinceListResponse } from '../interfaces/province';

const { REACT_APP_API_URL } = process.env;

export const provinces = async (params?: any) => {
  const requestQuery = {
    ...(params?.query || {}),
    populate: '*',
    pagination: {
      pageSize: 200,
    },
  };

  const { data } = await axios.get<ProvinceListResponse>(
    `${REACT_APP_API_URL}/provinces?${qs.stringify(requestQuery, { skipNulls: true })}`
  );
  return data;
};
